/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Random_TossInputs */



/**
* | output |
* | --- |
* | "Random toss" |
*
* @param {Players_Random_TossInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_random_toss = /** @type {((inputs?: Players_Random_TossInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Random_TossInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirage aléatoire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sorteo aleatorio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Toss aleatório")
	if (locale === "it") return /** @type {LocalizedString} */ ("Toss casuale")
	return /** @type {LocalizedString} */ ("Random toss")
});